/* =============================================================================
   BUTTON COMPONENT
   ============================================================================= */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  font-family: var(--font-sans);
  font-weight: 600;
  text-decoration: none;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-base);
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgb(255 255 255 / 10%) 0%, transparent 50%);
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.btn:hover::before {
  opacity: 1;
}

.btn:active {
  transform: scale(0.98);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn:disabled:hover::before {
  opacity: 0;
}

/* --- Icon --- */
.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-icon svg {
  width: 1.25em;
  height: 1.25em;
}

/* --- Sizes --- */
.btn-sm {
  padding: var(--space-sm) var(--space-md);
  font-size: 13px;
}

.btn-md {
  padding: var(--space-md) var(--space-xl);
  font-size: 14px;
}

.btn-lg {
  padding: var(--space-lg) var(--space-2xl);
  font-size: 16px;
}

/* --- Variants --- */
.btn-primary {
  background: var(--accent-gradient);
  color: var(--bg-primary);
  box-shadow:
    0 4px 16px rgb(0 230 122 / 30%),
    inset 0 1px 0 rgb(255 255 255 / 20%);
}

.btn-primary:hover {
  box-shadow:
    0 6px 24px rgb(0 230 122 / 40%),
    inset 0 1px 0 rgb(255 255 255 / 20%);
  transform: translateY(-2px);
}

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.btn-secondary:hover {
  background: var(--bg-elevated);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  box-shadow: 0 0 20px rgb(0 230 122 / 15%);
}

.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
  padding-left: var(--space-md);
  padding-right: var(--space-md);
}

.btn-ghost:hover {
  color: var(--accent-primary);
  background: var(--accent-tonal);
}

/* --- Full Width --- */
.btn-full {
  width: 100%;
}

/* --- Focus --- */
.btn:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}
